(function () {
    'use strict';

    // Detect page type
    const isCartPage = window.location.pathname.includes('/cart.php') || document.querySelector('.cart-item') !== null;
    const isCheckoutPage = window.location.pathname.includes('/checkout') || document.querySelector('.checkout-steps') !== null;

    // Always hide Bundle Product elements on all pages
    hideBundleProductElements();

    // Hide "Change" links on cart page for bundle products
    if (isCartPage) {
        hideChangeLinksForBundleProducts();
    }

    // Hide bundle product options on checkout page
    if (isCheckoutPage) {
        hideBundleProductOptionsOnCheckout();
    }

    // Wait for page to load
    setTimeout(() => {
        // If it's cart or checkout page, perform additional actions
        if (isCartPage || isCheckoutPage) {
            // Get current cart ID
            fetch('/api/storefront/carts', {
                method: "GET",
                credentials: "same-origin"
            })
                .then(response => response.json())
                .then(result => {
                    window.bigcommerceCartId = result.length ? result[0].id : null;

                    // If cart exists, validate bundle products
                    if (window.bigcommerceCartId) {
                        validateBundleCart(window.bigcommerceCartId);
                    }

                    // Start monitoring cart table for changes
                    observeCartChanges();
                })
                .catch(error => console.error('Failed to get cart:', error));
        }
    }, 1);

    function observeCartChanges() {
        const body = document.querySelector('div.body');

        if (!body) {
            return;
        }

        let validationTimeout = null;

        // Create a MutationObserver to watch for changes in the cart table
        const observer = new MutationObserver(function (mutations) {
            // Clear any existing timeout
            if (validationTimeout) {
                clearTimeout(validationTimeout);
            }

            // Set a new timeout to trigger validation after 1 second
            validationTimeout = setTimeout(function () {
                if (window.bigcommerceCartId) {
                    validateBundleCart(window.bigcommerceCartId);
                }

            }, 100);

            hideBundleProductElements();
            hideChangeLinksForBundleProducts();
        });

        // Configure observer to watch for changes in the cart table and its descendants
        observer.observe(body, {
            childList: true,
            subtree: true,
            attributes: false,
            characterData: true
        });
    }

    function observeCheckoutSummaryChanges() {
        const body = document.querySelector('.productList');
        if (!body) {
            return;
        }
        const observer = new MutationObserver(function (mutations) {
            hideBundleProductOptionsOnCheckout();
        });
        observer.observe(body, {
            childList: true,
            subtree: true,
            attributes: false,
            characterData: true
        });
    }

    function validateBundleCart(cartId) {
        // Get store data from script URL or other method
        const storeData = getStoreHashAndDomain();

        if (!storeData || !storeData.storeHash) {
            console.error('Store hash not found');
            return;
        }

        const validationUrl = `${storeData.domain}/storefront/${storeData.storeHash}/cart/validate-bundle?cart_id=${cartId}`;

        fetch(validationUrl, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                if (data.success && data.changed) {
                    // Show alert that bundle discounts were removed
                    alert(
                        'You have made changes to bundle products in your cart. Bundle discounts have been removed.\n\n' +
                        'If you want to buy multiple bundles, you must add the bundle product multiple times from the product page (one add per bundle).'
                    );
                    // Reload page to show updated cart
                    window.location.reload();
                }
            })
            .catch(error => console.error('Failed to validate bundle cart:', error));
    }

    function hideBundleProductElements() {
        // Hide form fields with "Bundle Product:" label
        const labels = document.querySelectorAll('.form-label');
        labels.forEach(label => {
            if (label.textContent.includes('Bundle Product:')) {
                const formField = label.closest('.form-field');
                if (formField) {
                    formField.style.display = 'none';
                }
            }
        });

        // Hide definition lists with "Bundle Product:" key
        const dtElements = document.querySelectorAll('.definitionList-key');
        dtElements.forEach(dt => {
            if (dt.textContent.includes('Bundle Product:')) {
                // Hide both dt and the corresponding dd element
                dt.style.display = 'none';
                const dd = dt.nextElementSibling;
                if (dd && dd.classList.contains('definitionList-value')) {
                    dd.style.display = 'none';
                }
            }
        });
    }

    function hideChangeLinksForBundleProducts() {
        // Find all cart items
        const cartItems = document.querySelectorAll('.cart-item');
        cartItems.forEach(item => {
            // Check if this item has Bundle Product definition
            const dtElements = item.querySelectorAll('.definitionList-key');
            let hasBundleProduct = false;

            dtElements.forEach(dt => {
                if (dt.textContent.includes('Bundle Product:')) {
                    hasBundleProduct = true;
                }
            });

            // If it has Bundle Product, hide the "Change" link
            if (hasBundleProduct) {
                const changeLink = item.querySelector('a[data-item-edit]');
                if (changeLink) {
                    changeLink.style.display = 'none';
                }
            }
        });
    }

    function hideBundleProductOptionsOnCheckout() {
        // Wait for productList class to appear on the page
        const checkForProductList = setInterval(() => {
            const productList = document.querySelector('.productList');

            if (productList) {
                clearInterval(checkForProductList);

                // Find all product options on checkout page
                const productOptions = document.querySelectorAll('li.product-option');
                productOptions.forEach(option => {
                    if (option.textContent.includes('Bundle Product')) {
                        option.style.display = 'none';
                    }
                });

                observeCheckoutSummaryChanges();
            }
        }, 10); // Check every 100ms

        // Safety timeout: stop checking after 10 seconds
        setTimeout(() => {
            clearInterval(checkForProductList);
        }, 5000);
    }

    function getStoreHashAndDomain() {
        // Try to get store hash and domain from current script's URL parameter
        const scripts = document.getElementsByTagName('script');
        for (let script of scripts) {
            const src = script.src;
            if (src && src.includes('sfbtu-checker.js')) {
                // Extract domain from URL
                const url = new URL(src);
                const domain = `${url.protocol}//${url.host}`;

                // Extract store_hash parameter
                const urlParams = new URLSearchParams(url.search);
                const storeHash = urlParams.get('store_hash');

                if (storeHash) {
                    return {
                        domain: domain,
                        storeHash: storeHash
                    };
                }
            }
        }

        // Fallback: try to get from window.BCData if available
        if (window.BCData && window.BCData.store_hash) {
            return {
                domain: window.location.origin,
                storeHash: window.BCData.store_hash
            };
        }

        return null;
    }
})();
